import { roles } from '@/enums'
import { useCurrentRoleStore } from '~/stores/currentRole'

export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const user = useSupabaseUser()
  if (!user.value) return navigateTo('/login')
  const currentRoleStore = useCurrentRoleStore()
  const currentRole = currentRoleStore.getCurrentRole()
  const schoolId = currentRole.schoolId
  const schoolRoles = await useSchoolMemberships().load()
  const isAdmin = schoolRoles.find(
    (schoolRole: SchoolRole) =>
      schoolRole.schoolId === schoolId && schoolRole.role === roles.ADMIN,
  )
  const fallbackAdmin = schoolRoles.find(
    (schoolRole: SchoolRole) => schoolRole.role === roles.ADMIN,
  )
  if (!isAdmin && !fallbackAdmin) {
    return navigateTo('/')
  }
  // Restore a usable admin context after a hard reload so protected pages never
  // fetch with an empty school id.
  if (!isAdmin && fallbackAdmin) currentRoleStore.setCurrentRole(fallbackAdmin)
})
